import React from 'react';
import { withNamespace } from '@ux/namespace-component';

/**
 * Representation of a footer in the Dialog.
 */
export default withNamespace(({ namespace, children }) =>
  <div className={ namespace('modal-nav') }>{ children }</div>
);



// WEBPACK FOOTER //
// ./node_modules/@ux/modal/modal-nav.js